import script from "./QuickActionsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickActionsTabs.vue?vue&type=script&setup=true&lang=ts"

import "./QuickActionsTabs.vue?vue&type=style&index=0&id=4e6986da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6986da"]])

export default __exports__